import { render, staticRenderFns } from "./NuveiCardListTable.vue?vue&type=template&id=25df6152&"
import script from "./NuveiCardListTable.vue?vue&type=script&lang=js&"
export * from "./NuveiCardListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports